import React, {useEffect} from 'react';
import * as SentryReact from '@sentry/react';
import ENV from '../environment';
const SentryWrapper = () => {
  const dsnNumber = ENV.SENTRY_DSN;
  useEffect(() => {
    if (!ENV.DEBUG_ENABLED) {
      SentryReact.init({
        dsn: dsnNumber,
        tracesSampleRate: 0.5,
        autoSessionTracking: false,
        ignoreErrors: [
          /\d+ms timeout exceeded/,
          /Internal error opening backing store for indexedDB\.open/,
          /backing store for indexedDB/,
          /Network Error/,
          /NetworkError/,
          /EventSource error/,
        ],
        denyUrls: [
          /chrome-extension:\/\//,
          /extensions\//,
          /^chrome:\/\//,
          /^moz-extension:\/\//,
          // Third-party analytics scripts throw their own (non-actionable)
          // cross-origin / SecurityErrors — not our code.
          /clarity\.js/,
          /clarity\.ms/,
        ],
      });
    }

    return () => {
      SentryReact.close();
    };
  }, [dsnNumber]);

  return null;
};

export default SentryWrapper;
